module.exports = __webpack_public_path__ + "static/media/bulk_force_closure_file.c4357b4a.csv";